import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { StudentGradeTypeResponse } from "../../models/dtos";

export const studentGradeTypesApi = createApi({
  reducerPath: 'studentGradeTypesApi',
  baseQuery: baseAuthQuery('StudentGradeTypes'),
  tagTypes: ['StudentGradeType'],
  endpoints: (builder) => ({
    getStudentGradeTypes: builder.query<ApiResponse<StudentGradeTypeResponse[]>, void>({
      query: () => "",
      providesTags: ['StudentGradeType'],
    }),
    getStudentGradeTypeById: builder.query<ApiResponse<StudentGradeTypeResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['StudentGradeType'],
    }),
    updateStudentGradeType: builder.mutation<ApiResponse<StudentGradeTypeResponse>, Partial<StudentGradeTypeResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['StudentGradeType'],
    }),
    deleteStudentGradeType: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['StudentGradeType'],
    }),
  }),
}); 